import React from "react";
import styled from "styled-components";

const Table = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.9fr 0.9fr 0.9fr 0.7fr 0.7fr 0.6fr;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border-top: 1px solid #f3f4f6;
  &:first-child { border-top: none; background: #fafafa; font-weight: 600; }
`;

const StatusPill = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: ${p => (
    p.status === 'active' ? '#065f46' :
    p.status === 'completed' ? '#1f2937' :
    p.status === 'cancelled' ? '#991b1b' : '#92400e'
  )};
  background: ${p => (
    p.status === 'active' ? '#ecfdf5' :
    p.status === 'completed' ? '#f3f4f6' :
    p.status === 'cancelled' ? '#fee2e2' : '#fffbeb'
  )};
  border: 1px solid ${p => (
    p.status === 'active' ? '#a7f3d0' :
    p.status === 'completed' ? '#e5e7eb' :
    p.status === 'cancelled' ? '#fecaca' : '#fde68a'
  )};
`;

const GhostButton = styled.button`
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
`;

export default function EventsTable({ events = [], onView, reportSendDate, onEditReport, onViewReportSchedule, onDeleteReportSchedule }) {
  const rows = Array.isArray(events) ? events : [];

  const formatDate = (isoString) => {
    if (!isoString) return '—';
    const date = new Date(isoString);
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric', month: 'short', day: 'numeric'
    }).format(date);
  };

  const formatResponseRate = (rate, totalInvited, totalResponded) => {
    if (rate !== undefined && rate !== null && !Number.isNaN(rate)) {
      return `${Math.round(Number(rate))}%`;
    }
    if (
      totalInvited !== undefined && totalInvited !== null && totalInvited > 0 &&
      totalResponded !== undefined && totalResponded !== null
    ) {
      const computed = (Number(totalResponded) / Number(totalInvited)) * 100;
      return `${Math.round(computed)}%`;
    }
    return '—';
  };

  return (
    <Table role="table" aria-label="Events">
      <Row>
        <div>Name</div>
        <div>Type</div>
        <div>Scheduled</div>
        <div>Close</div>
        <div>Response Rate</div>
        <div>Status</div>
        <div style={{ textAlign: 'right' }}>Actions</div>
      </Row>
      {!!reportSendDate && (
        <Row>
          <div style={{ fontWeight: 600 }}>Report Delivery</div>
          <div>Report delivery</div>
          <div>{formatDate(reportSendDate)}</div>
          <div>—</div>
          <div>—</div>
          <div>
            <StatusPill status={new Date(reportSendDate) > new Date() ? 'active' : 'completed'}>
              {new Date(reportSendDate) > new Date() ? 'scheduled' : 'sent'}
            </StatusPill>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            {new Date(reportSendDate) > new Date() ? (
              <>
                <GhostButton type="button" onClick={() => onEditReport?.()}>Edit</GhostButton>
                <GhostButton type="button" onClick={() => onDeleteReportSchedule?.()}>Delete</GhostButton>
              </>
            ) : (
              <GhostButton type="button" onClick={() => onViewReportSchedule?.()}>View</GhostButton>
            )}
          </div>
        </Row>
      )}
      {rows.map(ev => (
        <Row key={ev.id}>
          <div style={{ fontWeight: 600 }}>{ev.name}</div>
          <div style={{ textTransform: 'capitalize' }}>{String(ev.event_type || '').replace('_',' ')}</div>
          <div>{formatDate(ev.scheduled_date)}</div>
          <div>{formatDate(ev.close_date)}</div>
          <div>{formatResponseRate(ev.response_rate, ev.total_invited, ev.total_responded)}</div>
          <div><StatusPill status={ev.status}>{ev.status || 'scheduled'}</StatusPill></div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <GhostButton type="button" onClick={() => onView?.(ev)}>View</GhostButton>
          </div>
        </Row>
      ))}
      {rows.length === 0 && (
        <Row>
          <div style={{ gridColumn: '1 / -1', color: '#6b7280', fontSize: 13 }}>No events scheduled.</div>
        </Row>
      )}
    </Table>
  );
}


